import React, { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { billingInvoiceSocketInvoiceOnUpdate } from '@/features/billing/store'
import { ECHO_EVENT } from '@/features/socket/consts/echo'
// import { useEchoSubscriptionEffect } from '@/features/socket/hooks'
import { useUser } from '@/features/user/hooks'

interface IProps {
  children: React.ReactNode
}

export const BillingSocketMiddleware = ({ children }: IProps) => {
  const dispatch = useDispatch()

  const { user } = useUser()

  // const channel = `user.${user.id}`

  const events = useMemo(
    () => ({
      // new invoice received
      [ECHO_EVENT.UPDATE_BILLING_INVOICE_EVENT]: (data: any) =>
        dispatch(billingInvoiceSocketInvoiceOnUpdate(data)),
    }),
    [dispatch]
  )

  // useEchoSubscriptionEffect({ channel, events })

  return <>{children}</>
}
